import React, { createContext } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import type { RootState } from '../store';
import { IsLoading } from '../components/ui/isLoading';
export const StatusRefreshContext = createContext<() => void>(() => {});

export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { onboardingComplete, status } = useSelector((state: RootState) => state.auth.user);
  const accountType = useSelector((state: RootState) => state.auth.user.data?.accountType);
  const accountStatus = useSelector((state: RootState) => state.auth.user.data?.accountStatus);
  const location = useLocation();

  if (status !== "succeeded"){
    return (
      <div className='flex justify-center align-middle'>
        <IsLoading />
      </div>
    )
  }

  // 🔥 CRITICAL FIX: If CORPORATE user has corporate_complete status, ALWAYS go to dashboard
  // This prevents the infinite loop by not mounting CorporateOnboarding at all
  if (accountType === 'CORPORATE' && accountStatus === 'corporate_complete') {
    if (location.pathname === '/onboarding/corporate' || location.pathname === '/onboarding') {
      console.log('✅ CORPORATE user with corporate_complete detected, redirecting to dashboard');
      return <Navigate to="/dashboard" replace state={{ from: location }} />;
    }
  }

  // 🔥 CRITICAL FIX: Don't redirect CORPORATE users to /onboarding
  // CORPORATE users use /onboarding/corporate, not /onboarding
  if (!onboardingComplete && location.pathname === '/dashboard') {
    // If user is CORPORATE, redirect to corporate form instead
    // BUT: Don't redirect if corporate onboarding is already complete
    if (accountType === 'CORPORATE' && accountStatus !== 'corporate_complete') {
      return <Navigate to="/onboarding/corporate" replace state={{ from: location }} />;
    }
    // For EXPRESS/INDIVIDUAL users
    if (accountType !== 'CORPORATE') {
      return <Navigate to="/onboarding" replace state={{ from: location }} />;
    }
  }

  // Redirect to dashboard if onboarding is complete and trying to access onboarding
  // EXCEPT if it's an upgrade process (check localStorage flag)
  const isUpgrading = localStorage.getItem('upgradeFromExpress') === 'true';
  if (onboardingComplete && location.pathname === '/onboarding' && !isUpgrading) {
    return <Navigate to="/dashboard" replace state={{ from: location }} />;
  }

  // Render the children if access is allowed
  return <>{children}</>;
};